import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformServer, isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { environment } from 'projects/shared/environments/environment';

@Injectable({ providedIn: 'root' })
export class IpService {
  ip$ = new BehaviorSubject<string>('')
  constructor(private http: HttpClient) { }

  getPublicIp(): Observable<any> {
    return this.http.get(`${environment.apiUrl}utils/get-ip`, {withCredentials: true});
  }

  async getIP() {
    this.getPublicIp().subscribe(
      res => {
        console.log('res: ', res);
        this.ip$.next(res.ip)
      }
    )
  }

}